import { render, staticRenderFns } from "./shipmenttable.vue?vue&type=template&id=3c0d9a34"
import script from "./shipmenttable.vue?vue&type=script&lang=js"
export * from "./shipmenttable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports